import { useQuery } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';

/**
 * GET /api/eraf/saga-monitor/instances/{id} — 사가 인스턴스 상세
 * queryKey: ['saga-monitor', 'detail', id]
 */
export function useSagaInstance(id: number | null) {
  return useQuery({
    queryKey: ['saga-monitor', 'detail', id],
    queryFn: () => sagaMonitorApi.getInstance(id!),
    enabled: id !== null,
    staleTime: 15_000,
  });
}
